import { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import TrueWellnessHeader from "@/components/truewellness/TrueWellnessHeader";
import TrueWellnessHero from "@/components/truewellness/TrueWellnessHero";
import MedicalWeightLoss from "@/components/truewellness/MedicalWeightLoss";
import PeptideTreatmentCards from "@/components/truewellness/PeptideTreatmentCards";
import NudaLabsIntro from "@/components/truewellness/NudaLabsIntro";
import TrueWellnessJourney from "@/components/truewellness/TrueWellnessJourney";
import TrueWellnessSupport from "@/components/truewellness/TrueWellnessSupport";
import TrueWellnessFooter from "@/components/truewellness/TrueWellnessFooter";
import FloatingBookCTA from "@/components/truewellness/FloatingBookCTA";
import LearnMoreModal from "@/components/truewellness/LearnMoreModal";
import GLP1PriceComparison from "@/components/truewellness/GLP1PriceComparison";
import { CookieConsent } from "@/components/CookieConsent";
import TrueWellnessFAQ from "@/components/truewellness/TrueWellnessFAQ";
import TrueWellnessTestimonials from "@/components/truewellness/TrueWellnessTestimonials";

const categories = ["Weight", "Energy", "Mood", "Sleep", "Hair", "Skin", "Recovery"];

const TrueWellness = () => {
  const [learnMoreOpen, setLearnMoreOpen] = useState(false);
  const [nudaModalOpen, setNudaModalOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  // Auto-rotation paused - keeping static on first slide for now
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setIsTransitioning(true);
  //     setTimeout(() => {
  //       setCurrentIndex((prev) => (prev + 1) % categories.length);
  //       setIsTransitioning(false);
  //     }, 300);
  //   }, 3000);
  //
  //   return () => clearInterval(interval);
  // }, []);

  const handleOpenModal = () => {
    setLearnMoreOpen(true);
  };

  const handleOpenNudaModal = () => {
    setNudaModalOpen(true);
  };

  return (
    <>
      <Helmet>
        <title>TrueWellness – Provider-Guided Wellness Programs | Personalized Peptide Protocols</title>
        <meta 
          name="description" 
          content="Provider-guided wellness programs with personalized peptide protocols. Connect with licensed providers for individualized care plans designed to support your wellness goals." 
        />
        <meta 
          name="keywords" 
          content="wellness programs, peptide protocols, provider-guided care, personalized wellness, telehealth wellness, peptide subscription, wellness support, licensed providers" 
        />
        <link rel="canonical" href="https://www.mytruewellness.com" />
        <meta property="og:title" content="TrueWellness – Provider-Guided Wellness Programs" />
        <meta property="og:description" content="Personalized wellness care. Connect with licensed providers for individualized protocols designed to support your wellness journey." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.mytruewellness.com" />
      </Helmet>
      
      <div className="min-h-screen bg-background overflow-x-hidden">
        <TrueWellnessHeader 
          onOpenModal={handleOpenModal}
          activeCategory={currentIndex}
          isTransitioning={isTransitioning}
        />
        <main className="space-y-0">
          <TrueWellnessHero 
            onOpenModal={handleOpenModal} 
            currentIndex={currentIndex}
            isTransitioning={isTransitioning}
            setCurrentIndex={setCurrentIndex}
            setIsTransitioning={setIsTransitioning}
          />
          {/* Peptide sections hidden for now - will add back later */}
          {/* <MedicalWeightLoss onOpenModal={handleOpenModal} /> */}
          {/* <NudaLabsIntro onOpenModal={handleOpenNudaModal} nudaLink="https://nudalabs.com/nudalabs-home/" /> */}
          {/* <PeptideTreatmentCards onOpenModal={handleOpenModal} /> */}
          <GLP1PriceComparison />
          <TrueWellnessSupport onOpenModal={handleOpenModal} />
          <TrueWellnessTestimonials />
          <TrueWellnessFAQ />
          {/* <TrueWellnessJourney onOpenModal={handleOpenModal} /> */}
        </main>
        <TrueWellnessFooter />
        <FloatingBookCTA onOpenModal={handleOpenModal} />
        <LearnMoreModal open={learnMoreOpen} onOpenChange={setLearnMoreOpen} sourcePage="home_page" />
        <LearnMoreModal open={nudaModalOpen} onOpenChange={setNudaModalOpen} redirectToNuda={true} nudaLink="https://nudalabs.com/nudalabs-home/" sourcePage="home_page" />
        <CookieConsent />
      </div>
    </>
  );
};

export default TrueWellness;
